(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cadoro-color-check"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cadoro-library-check')) {
  customElements.define('cadoro-library-check', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const success = this.querySelector('[data-library-success]');
      if (success) {
        success.focus();
        this.scrollIntoView({block:'center',behavior:'smooth'});
      }
      const form = this.querySelector('form');
      const status = this.querySelector('[data-library-status]');
      const frame = this.querySelector('.ccheck__frame');
      if (frame) {
        this.addEventListener('submit', () => { this.submitted = true; frame.hidden = false; });
        window.addEventListener('message', event => {
          if (!this.submitted || event.origin !== location.origin || event.source !== frame.contentWindow || event.data?.type !== 'cadoro-library-check-success') return;
          frame.hidden = true;
          form.hidden = true;
          const confirmation = this.querySelector('[data-library-embedded-success]');
          confirmation.hidden = false;
          confirmation.focus();
          confirmation.scrollIntoView({block:'center',behavior:'smooth'});
        });
      }
      const showVerification = () => {
        if (!status || !form.checkValidity()) return;
        status.textContent = this.dataset.verificationPrompt;
        status.hidden = false;
      };
      form.querySelector('[type=submit]')?.addEventListener('click', showVerification);
      form.addEventListener('submit', () => {
        showVerification();
        const color = Object.fromEntries([...this.querySelectorAll('[data-library-field]')].map(input => [input.dataset.libraryField, input.value.trim()]));
        this.querySelector('[data-library-title]').value = `Cadoro Color Check — ${color.brand} ${color.code} ${color.name}`;
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
